// extracted by mini-css-extract-plugin
export default {"heading":"Canned_heading__Mrfqd","grid":"Canned_grid__-sUhE","card":"Canned_card__PCu8a"};